export enum RoleType {
  PREDICATOR = 'predicator',
  INDEMN = 'indemn',
  CANTARE = 'cantare',
  PIAN = 'pian',
  GRUP = 'grup',
}

export enum AssignmentStatus {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  DECLINED = 'declined',
  SWAP_REQUESTED = 'swap_requested',
  SWAPPED = 'swapped',
}

export interface RoleAssignment {
  id: string;
  event_id: string;
  role_type: RoleType;
  member_id: string | null;
  group_id: string | null;
  display_order: number;
  bible_reference: string | null;
  notes: string | null;
  status: AssignmentStatus;
  confirmed_at: string | null;
  declined_at: string | null;
  decline_reason: string | null;
  assigned_by: string | null;
  member?: {
    id: string;
    first_name: string;
    last_name: string;
    photo_path: string | null;
  } | null;
  group?: {
    id: string;
    name: string;
  } | null;
  event?: {
    id: string;
    title: string;
    event_date: string;
    start_time: string;
    category: string;
  } | null;
  assigned_by_user?: {
    id: string;
    name: string;
  } | null;
  created_at: string;
  updated_at: string;
}

export interface RoleQualification {
  id: string;
  member_id: string;
  role_type: RoleType;
  source: 'manual' | 'group_inheritance';
  source_group_id: string | null;
  qualified_since: string | null;
}

export interface GroupRoleQualification {
  id: string;
  group_id: string;
  role_type: RoleType;
}

export interface MemberBlockout {
  id: string;
  member_id: string;
  starts_on: string;
  ends_on: string;
  reason: string | null;
}

export interface SwapRequest {
  id: string;
  assignment_id: string;
  requested_by: string;
  status: 'open' | 'claimed' | 'cancelled' | 'expired';
  claimed_by: string | null;
  reason: string | null;
  expires_at: string | null;
}

export interface QualifiedMember {
  id: string;
  first_name: string;
  last_name: string;
  photo_path: string | null;
  is_blocked_out: boolean;
}

export const ROLE_LABELS: Record<RoleType, string> = {
  [RoleType.PREDICATOR]: 'Predicator',
  [RoleType.INDEMN]: 'Îndemn',
  [RoleType.CANTARE]: 'Cântare',
  [RoleType.PIAN]: 'Pian',
  [RoleType.GRUP]: 'Grup',
};

export const ROLE_ORDER: RoleType[] = [
  RoleType.PREDICATOR,
  RoleType.INDEMN,
  RoleType.CANTARE,
  RoleType.PIAN,
  RoleType.GRUP,
];
